<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-select v-model="tableParams.auditStatus" clearable  placeholder="审核状态"
                 style="margin-right: 15px; width: 110px">
        <el-option v-for="item in statusList" :label="item.lable" :value="item.value" :key="item.value"/>
      </el-select>
      <search-dsp-select v-model="tableParams.dspId" :dspType="100"/>
      <el-input v-model="tableParams.word"  placeholder="请输入包名或应用名或渠道号" style="margin-right: 15px"/>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px"/>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
      <el-button @click="downExcelCSV('/distOppoAudit/list/csv', 'OPPO审核列表', tableParams)" type="warning" size="small">
        下载
      </el-button>
    </div>

    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
                    style="padding-bottom: 10px">
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
                highlight-current-row size="small" class="js-table" style="width: 100%">
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
                         :min-width="v.minWidth" :key="i" align="center">
          <template v-slot="scope">
            <span v-if="v.field === 'auditStatus'">{{
                statusMap[scope.row.auditStatus]
              }}</span>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
                     :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize"
                     :page-sizes="[10, 30, 60]"
                     background layout="total,sizes,prev,pager,next" style="margin-top: 40px"/>
    </div>
  </div>
</template>

<script>
import SearchDspSelect from '@/components/SearchDspSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import TableColumn from '@/components/TableColumn'
import initTableMixin from '@/mixins/initTable'
import {downExcelMixin} from '@/mixins/downExcel'

export default {
  name: 'Manage/channel/auditResult',
  components: {
    SearchDspSelect,
    BaseDatePicker,
    TableColumn
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      test: undefined,
      columns: [
        {field: 'dspName', title: '上游名称'},
        {field: 'oppoChannel', title: 'OPPO渠道号'},
        {field: 'apkName', title: '名称'},
        {field: 'apkBundle', title: '应用包名'},
        {field: 'verName', title: '版本名'},
        {field: 'apkMd5', title: '应用MD5'},
        {field: 'cpuModel', title: 'CPU架构'},
        {field: 'appUrl', title: '下载地址'},
        {field: 'auditStatus', title: '审核状态'},
        {field: 'auditMsg', title: '审核描述'},
        {field: 'createTime', title: '创建时间'},
        {field: 'updateTime', title: '审核时间'}
      ],

      statusList: [
        {value: 0, lable: '待审核'},
        {value: 1, lable: '已上架'},
        {value: 2, lable: '审核不通过'},
        {value: 3, lable: '已下架'}
      ],
      statusMap: ['待审核', '已上架', '审核不通过', '已下架']
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit() {
      this.tableUrl = '/distOppoAudit/list'
      return true
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}
</style>
